const state = {
  shippingAddress: {},
  orderSummary: {},
  referralCode: null
}

export default state
